module.exports = __webpack_public_path__ + "static/assets/1bb0adb555e07593962e9fc28ec7566d.svg";